/**
 * Pure helpers for the staff Package Builder UI.
 *
 * Kept in a plain .ts module (no React) so they are unit-testable under the
 * node-env vitest setup — the .tsx components stay presentational.
 */

/** Sanitize a public URL slug: lowercase, non [a-z0-9-] → '-'. Mirrors FormBuilderPage. */
export function sanitizeSlug(input: string): string {
  return input.toLowerCase().replace(/[^a-z0-9-]/g, '-');
}

/**
 * Move the item at `index` one position in `direction` (-1 = up, +1 = down),
 * returning a NEW array. Out-of-range moves are no-ops (return a copy unchanged).
 */
export function moveItem<T>(arr: readonly T[], index: number, direction: -1 | 1): T[] {
  const next = arr.slice();
  const target = index + direction;
  if (index < 0 || index >= next.length || target < 0 || target >= next.length) {
    return next;
  }
  const [moved] = next.splice(index, 1);
  next.splice(target, 0, moved as T);
  return next;
}

/** Remove the item at `index`, returning a NEW array (no-op copy if out of range). */
export function removeAt<T>(arr: readonly T[], index: number): T[] {
  const next = arr.slice();
  if (index < 0 || index >= next.length) return next;
  next.splice(index, 1);
  return next;
}
